 document.addEventListener('DOMContentLoaded', function() {
  var element = document.querySelector('.evey__multi-variant-selector');
  var lastScrollTop = 0;
  var stickyOffset = 50; // 50 pixels from the bottom
  var isSticky = false;
  var originalPosition = element.getBoundingClientRect().top + window.scrollY;

  function updateStickyPosition() {
    var elementRect = element.getBoundingClientRect();
    var windowHeight = window.innerHeight;
    // Calculate the position where the sticky class should be removed
    stickyPosition = originalPosition + stickyOffset;
  }

    function checkInitialPosition() {
      var elementRect = element.getBoundingClientRect();
      var windowHeight = window.innerHeight;
  
      if (elementRect.bottom >= windowHeight - stickyOffset) {
        if (!isSticky) {
          element.classList.add('sticky');
          isSticky = true;
          updateStickyPosition(); // Update sticky position when sticky class is added
        }
      }
    }

    // Check position on initial load
    checkInitialPosition();

    // Handle scroll events
    window.addEventListener('scroll', function() {
      var currentScrollTop = window.scrollY;
      var elementRect = element.getBoundingClientRect();
      var windowHeight = window.innerHeight;
      var elementBottom = elementRect.bottom;
  
      // Check if scrolling up
      if (currentScrollTop < lastScrollTop) {
        // Check if element touches bottom at stickyOffset
        if (elementBottom >= windowHeight - stickyOffset) {
          if (!isSticky) {
            element.classList.add('sticky');
            isSticky = true;
            updateStickyPosition(); // Update sticky position when sticky class is added
          }
        }
      } else {
        // Remove sticky class when reaching the original position
        if (isSticky && currentScrollTop >= stickyPosition) {
          element.classList.remove('sticky');
          isSticky = false;
        }
      }
  
      lastScrollTop = currentScrollTop;
    });
  
    // Update sticky position on window resize
    window.addEventListener('resize', function() {
      updateStickyPosition();
    });
  });







// <!------------   This JS is Seprate    -------->>

// <!------------   Convert text of button   -------->>

document.addEventListener("DOMContentLoaded", function() {
  var button = document.querySelector(".product-form__submit span");
  if (button) {
    button.textContent = "In den Warenkorb";
  }
});





// <!------------   This JS is Seprate    -------->>

// <!------------   Add width dynimically for  'multiVariantSelector' varibles element  -------->>


const fullSection = document.getElementsByClassName('product')[0];
const section = document.getElementsByClassName('product-gallery')[0];
const sectionFull = document.querySelector('.section-full');
const multiVariantSelector = document.querySelector('.evey__multi-variant-selector');

function getSectionData() {
  const fullSectionWidth = fullSection.offsetWidth;
  const sectionWidth = section.offsetWidth;
  const widthDifference = fullSectionWidth - sectionWidth;

  const computedStyle = window.getComputedStyle(sectionFull);
  const paddingTop = parseFloat(computedStyle.paddingTop);
  const paddingRight = parseFloat(computedStyle.paddingRight);
  const paddingBottom = parseFloat(computedStyle.paddingBottom);
  const paddingLeft = parseFloat(computedStyle.paddingLeft);
  const totalPadding = paddingTop + paddingRight + paddingBottom + paddingLeft;

  // Set the max-width of the multi-variant selector
  multiVariantSelector.style.width = widthDifference + paddingRight + 'px';

}

// Initial calculation
getSectionData();

// Event listener for window resize
window.addEventListener('resize', getSectionData);














































